/** @format */

export enum TagType {
  SUCCESS,
  ERROR,
  WARNING,
  PRIMARY,
}
